<h1 i18n="@@upp.dynamicExclusions.search.title" data-test="dynamic-exclusion-rule-search-title"
  >Search Dynamic Exclusion Rules</h1
>

<div class="container-fluid">
  <ama-loading-alert
    [sendingStatus]="(fareRuleDeleteSending$ | async) ?? false"
    message="Loading..."
    i18n-message="@@upp.global.messages.loading"
  >
  </ama-loading-alert>
</div>

<ama-upp-notification
  id="fares-search-notification"
  class="col"
  [mainMessages]="mainMessages"
  [notification]="(notification$ | async)!"
  (closeNotificationEvent)="closeNotification()"
>
</ama-upp-notification>

<ama-ng-upp-fares-search-criteria
  (searchFares)="searchFareRules($event)"
  (clearFares)="clearFareRules()"
  [sendingStatus]="(fareRuleSearchSending$ | async) ?? false"
>
</ama-ng-upp-fares-search-criteria>

@if (!agGridTablesActivated) {
<ama-ng-upp-basic-search-result-table
  [searchResults]="(fareRules$ | async) ?? undefined"
  [sendingStatus]="(fareRuleSearchSending$ | async) ?? undefined"
  [sourceComponent]="getSourceComponent()"
  [entryType]="getEntryType()"
  [recordToSearchResult]="recordToSearchResult"
  [entryToUpdateCreator]="entryToUpdateCreator"
  [entryToUpdateNameResolver]="entryToUpdateNameResolver"
  (deleteEntry)="deleteFareRule($any($event))"
  (clearTableEvent)="clearFareRules()"
  (showDetail)="showFareRule($event)"
  (modifyDetail)="modifyFareRule($event)"
  [managePermission]="managePermission"
  [copyForbidden]="true"
  [displayableFields]="displayableFields"
  [nameColumnPosition]="troubleShootingEnabled ? 'displayableFields' : 'first'"
></ama-ng-upp-basic-search-result-table>
} @else {
<div class="row mt-7">
  <div id="search-result" class="col">
    <div [class]="agGridTheme" class="grid-container">
      <ag-grid-angular
        [rowData]="(transformedFareRules$ | async) ?? []"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        [defaultColDef]="defaultColDef"
        (gridReady)="onGridReady($event)"
        class="grid-component"
      ></ag-grid-angular>
    </div>
  </div>
</div>
}
